import * as Yup from 'yup';

export const schema = Yup.object().shape({
  url: Yup.string()
    .required('Este campo es requerido')
    .matches(
      /^https:\/\/(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/,
      'El webhook debe ser una URL válida (debe contener https://)',
    ),
});
